import ErrorPage from "../components/generic/ErrorPage";
import AboutComponent from "../experience/aboutus/AboutComponent";
import Authentication from "../experience/auth/login/Authentication";
import DemoLoginPage from "../experience/auth/login/DemoLoginPage";
import Logout from "../experience/auth/logout/Logout";
import AuthValidator from "../experience/auth/validator/AuthValidator";
import AnnouncementComponent from "../experience/carecoordinator/annoucement/AnnouncementComponent";
import AuditLogs from "../experience/carecoordinator/auditlog/AuditLogs";
import GenericAuditLogs from "../experience/carecoordinator/auditlog/GenericAuditLogs";
import FormSummary from "../experience/carecoordinator/formsummary/FormSummary";
import CareCoordinatorDashboard from "../experience/carecoordinator/CareCoordinator";
import ManageInvitationComponent from "../experience/carecoordinator/manageinvitations/ManageInvitationComponent";
import OrganizationCreation from "../experience/carecoordinator/organizationcreation/OrganizationCreation";
import Organizations from "../experience/carecoordinator/organizationcreation/Organizations";
import PatientListComponent from "../experience/carecoordinator/patientlist/PatientListComponent";
import ReportingLogs from "../experience/carecoordinator/reportinglog/ReportingLogs";
import RequestForVolunteeringService from "../experience/carecoordinator/requestforvolunteeringservice/RequestForVolunteeringService";
import WorkforceListComponent from "../experience/carecoordinator/workforcelist/WorkforceListComponent";
import CareProviderDashboard from "../experience/careprovider/CareProvider";
import Journal from "../experience/careprovider/journal/Journal";
import SmartAssistant from "../experience/careprovider/smart-assistant/SmartAssistance";
import TrainingHomePageComponent from "../experience/careprovider/training/traininghomepage/TrainingHomePageComponent";
import ContactUs from "../experience/contactus/ContactUs";
import FeatureComponent from "../experience/Featurepage/FeatureComponent";
import FormCreatorWrapper from "../experience/generic/elements/formwrapper/creator/FormCreatorWrapper";
import ListFormWrapper from "../experience/generic/elements/formwrapper/list/ListFormWrapper";
import FormViewerComponent from "../experience/generic/elements/formwrapper/renderer/FormViewerComponent";
import InvitationComponent from "../experience/invitation/InvitationComponent";
import PdvLandingPage from "../experience/landingpage/PdvLandingPage";
import OrganizationSettingsPage from "../experience/organizationsettings/OrganizationSettingsPage";
import CoordinatorProfilePage from "../experience/organizationsettings/profilepages/CoordinatorProfilePage";
import PatientProfilePage from "../experience/organizationsettings/profilepages/PatientProfilePage";
import VolunteerProfilePage from "../experience/organizationsettings/profilepages/VolunteerProfilePage";
import PrivacyPolicy from "../experience/privacypolicy/PrivacyPolicy";
import VolunteerPageComponent from "../experience/volunteerpage/VolunteerPageComponent";
import BillingDashboard from "../billing/pages/BillingDashboard";
import ChatContainer from "../experience/chat/ChatContainer";

export const coordinatorRoutes = [
    { path: "homepage", element: <CareCoordinatorDashboard /> },
    { path: "announcements", element: <AnnouncementComponent /> },
    { path: "invite", element: <ManageInvitationComponent /> },
    { path: "form-builder", element: <ListFormWrapper /> },
    { path: "create-form", element: <FormCreatorWrapper /> },
    { path: "patient", element: <PatientListComponent /> },
    { path: "workforce", element: <WorkforceListComponent /> },
    { path: "form-viewer", element: <FormViewerComponent /> },
    { path: "logout", element: <Logout /> },
    { path: "organization-settings", element: <OrganizationSettingsPage /> },
    { path: "cooordinator-profile", element: <CoordinatorProfilePage /> },
    { path: "volunteer-profile", element: <VolunteerProfilePage /> },
    { path: "patient-profile", element: <PatientProfilePage /> },
    { path: "request-for-volunteering-service", element: <RequestForVolunteeringService />, },
    { path: "audit-logs", element: <AuditLogs /> },
    { path: "generic-audit-logs", element: <GenericAuditLogs /> },
    { path: "reporting-logs", element: <ReportingLogs /> },
    { path: "training", element: <TrainingHomePageComponent /> },
    { path: "organizations", element: <Organizations /> },
    { path: "organization-creator", element: <OrganizationCreation /> },
    { path: "journal", element: <Journal /> },
    { path: "forms-summary", element: <FormSummary /> },
    { path: "billing", element: <BillingDashboard /> },
    { path: "communication", element: <ChatContainer /> },
];

export const volunteerRoutes = [
    { path: "homepage", element: <CareProviderDashboard /> },
    { path: "announcements", element: <AnnouncementComponent /> },
    { path: "form-viewer", element: <FormViewerComponent /> },
    { path: "training", element: <TrainingHomePageComponent /> },
    { path: "smart-assistant", element: <SmartAssistant /> },
    { path: "logout", element: <Logout /> },
    { path: "volunteer-profile", element: <VolunteerProfilePage /> },
    { path: "patient-profile", element: <PatientProfilePage /> },
    { path: "request-for-volunteering-service", element: <RequestForVolunteeringService /> },
    { path: "journal", element: <Journal /> },
    { path: "communication", element: <ChatContainer /> },
];

export const routes = [
    { path: "/", element: <PdvLandingPage /> },
    { path: "/contact-us", element: <ContactUs /> },
    { path: "/about", element: <AboutComponent /> },
    { path: "/privacy-policy", element: <PrivacyPolicy /> },
    { path: "/feature", element: <FeatureComponent /> },
    { path: "/volunteer", element: <VolunteerPageComponent /> },
    { path: "/login", element: <DemoLoginPage /> },
    { path: "/invitation", element: <InvitationComponent /> },
    { path: "/auth/validate", element: <AuthValidator /> },
    { path: "/authenticate", element: <Authentication /> },
    { path: "/error", element: <ErrorPage /> },
    { path: "*", element: <ErrorPage code={1002} /> },
]